import { v7 as uuidv7, validate, version } from 'uuid';

/**
 * Every record id is a UUIDv7 (CLAUDE.md §3.3): time-ordered, and generated on the device that
 * creates the record, so records made offline never collide.
 */
export function newId(): string {
  return uuidv7();
}

export function isUuidV7(value: string): boolean {
  return validate(value) && version(value) === 7;
}
